import { render, staticRenderFns } from "./MedicationEntryModal.vue?vue&type=template&id=4f82cfbf&scoped=true"
import script from "./MedicationEntryModal.vue?vue&type=script&lang=js"
export * from "./MedicationEntryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f82cfbf",
  null
  
)

export default component.exports